<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M105.299 85.1779C84.6438 81.0393 102.646 55.3162 111.151 57.6523C122.204 60.69 86.8903 106.195 27.3945 71.3666"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M28.3985 67.6422C28.3985 67.6422 27.9209 57.3201 31.6788 57.432C41.2508 57.7119 79.7515 63.3245 107.568 55.234"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.1858 71.2695V67.7132C84.1858 67.0041 83.5887 66.4369 82.8796 66.4742C81.2712 66.56 79.5173 66.6309 77.629 66.6795C76.9573 66.6981 76.4199 67.2467 76.4199 67.9184V71.5644C76.4199 72.2659 77.0021 72.8294 77.7037 72.8033C79.4651 72.7399 81.2451 72.6428 83.0364 72.5048C83.682 72.4563 84.182 71.9151 84.182 71.2695H84.1858Z"
            class="primary-fill" />
        <path
            d="M74.543 71.6465V67.9819C74.543 67.2952 73.9869 66.7392 73.3003 66.7429C71.6396 66.7504 69.8969 66.7392 68.0795 66.7019C67.3854 66.687 66.8145 67.2467 66.8145 67.9408V71.5607C66.8145 72.2287 67.3444 72.7772 68.0124 72.7996C69.7476 72.8593 71.5128 72.8892 73.3078 72.8854C73.9907 72.8854 74.5467 72.3294 74.5467 71.6465H74.543Z"
            class="primary-fill" />
        <path
            d="M39.5721 67.7094V65.3733C39.5721 64.7613 39.128 64.2426 38.5234 64.1493C37.4412 63.9814 36.3515 63.806 35.2507 63.6231C34.4931 63.4963 33.8027 64.0784 33.8027 64.8434V66.922C33.8027 67.4893 34.1871 67.9856 34.7394 68.1237C35.6462 68.355 36.762 68.6237 38.057 68.9185C38.8332 69.0939 39.5721 68.5043 39.5721 67.7094Z"
            class="primary-fill" />
        <path
            d="M47.4986 69.2843V66.4481C47.4986 65.8212 47.0284 65.2912 46.4052 65.2166C45.2371 65.0785 44.0542 64.933 42.8563 64.7725C42.1136 64.6718 41.4531 65.2502 41.4531 66.0003V68.6275C41.4531 69.2208 41.8711 69.7321 42.4532 69.844C43.5765 70.0642 44.7781 70.2844 46.0469 70.5045C46.8045 70.6352 47.4986 70.053 47.4986 69.2843Z"
            class="primary-fill" />
        <path
            d="M64.9364 71.3479V67.8139C64.9364 67.1497 64.4102 66.6011 63.746 66.575C62.3391 66.519 60.8949 66.4481 59.4171 66.3623C58.7043 66.3212 58.1035 66.8847 58.1035 67.5975V71.0083C58.1035 71.6502 58.5924 72.1838 59.2305 72.2436C60.6598 72.3742 62.1226 72.4899 63.6191 72.5832C64.3319 72.6279 64.9364 72.0607 64.9364 71.3442V71.3479Z"
            class="primary-fill" />
        <path
            d="M56.2246 70.5531V67.3027C56.2246 66.6571 55.7283 66.116 55.0827 66.0675C53.6609 65.9556 52.2129 65.8287 50.7351 65.6869C50.0074 65.616 49.373 66.1869 49.373 66.9184V69.9784C49.373 70.5942 49.8246 71.1166 50.4329 71.2062C51.8435 71.4114 53.3138 71.6055 54.8364 71.7883C55.5753 71.8742 56.2246 71.2995 56.2246 70.5568V70.5531Z"
            class="primary-fill" />
        <path
            d="M93.6301 56.6074C93.6301 56.6074 90.5327 49.5506 90.1894 48.3788C90.1894 48.3788 55.2562 51.8344 44.7811 49.6439C43.9899 49.4797 43.1951 49.92 42.9227 50.685C42.2845 52.4651 41.1725 55.4393 40.4746 56.6111"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.144 58.3501L75.0318 53.4913C74.6623 52.6405 75.2333 51.6739 76.155 51.5881L90.8918 50.2036"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M22.9648 77.6732C22.9648 77.6732 34.6304 77.009 32.4062 78.3188C30.1821 79.6287 28.1893 83.8568 36.3992 83.3605C44.6092 82.8641 53.8155 82.95 50.33 84.5211C46.8482 86.0921 51.4943 88.3387 60.1184 87.8386C68.7426 87.3386 79.6804 85.3234 75.6986 87.9506C71.7168 90.5777 78.6878 89.8015 84.6623 87.9506C90.6369 86.0996 98.9625 84.4016 95.5405 87.3871C92.1184 90.3725 102.079 89.6448 102.079 89.6448"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.834 42.5236L84.4536 48.0056"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.7285 43.7365L75.3518 49.2184"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.1084 44.6768L59.791 48.8079"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M24.1186 54.9989C24.1186 54.9989 18.7001 53.2375 14.834 50.0804"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M26.3953 58.3053C26.3953 58.3053 22.1336 57.238 19.2266 56.3013"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M28.9506 53.9727C28.9506 53.9727 22.8529 52.8233 20.375 50.7"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.7039 42.6244C79.8151 40.7361 73.8182 43.7365 73.8182 43.7365L60.9473 44.4679C60.9473 44.4679 65.6083 41.4601 72.4486 41.337C75.7326 41.2772 82.2595 41.1541 85.7039 42.6244Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M48.318 53.0958C51.643 53.2898 62.2935 53.8384 69.0032 53.4167C69.7197 53.3719 70.3504 53.8906 70.44 54.6034L70.4922 55.0251C70.593 55.8162 69.9959 56.5178 69.201 56.5551C65.7641 56.7007 56.8414 56.9208 48.0642 55.8013C47.2097 55.6931 46.676 54.8236 46.9522 54.01C47.15 53.4316 47.706 53.0584 48.3143 53.0958H48.318Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
